module.exports = __webpack_public_path__ + "img/game-finished.f14f8aac.png";